import React from "react";
import { Box, Chip, Divider, Typography } from "@mui/material";

const PainelCard = ({ icon, iconBg, iconColor, title, chipLabel, chipBg, chipColor, description, children }) => (
    <Box
        sx={{
            backgroundColor: 'white',
            borderRadius: '20px',
            border: '1px solid rgba(19, 35, 80, 0.08)',
            boxShadow: '0px 2px 16px rgba(19, 35, 80, 0.06)',
            p: { xs: 3, md: 4 },
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
            <Box
                sx={{
                    width: 44,
                    height: 44,
                    borderRadius: '12px',
                    backgroundColor: iconBg,
                    color: iconColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                {icon}
            </Box>

            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '1.05rem', color: '#132350' }}>
                        {title}
                    </Typography>
                    <Chip
                        label={chipLabel}
                        size="small"
                        sx={{ backgroundColor: chipBg, color: chipColor, fontWeight: 500, height: '1.4rem' }}
                    />
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5, textAlign: 'justify', minHeight: '2.5rem' }}>
                    {description}
                </Typography>
            </Box>
        </Box>

        <Divider sx={{ my: 2.5 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            {children}
        </Box>
    </Box>
);

export default PainelCard;
